import { DateObject } from '../objects/models/date.field.value';
import addLeadingZeroes from './addLeadingZeroes';

export default function getDateStringFromObject(dateObject: DateObject) {
    return `${dateObject.year}-${addLeadingZeroes(+dateObject.month, 2)}-${addLeadingZeroes(+dateObject.day, 2)}`;
}
